// @flow
import PreferencesWidget from '../PreferencesWidget/PreferencesWidget';
import type { DialogState } from '../PreferencesWidget/types';
import UserWidget from '../UserWidget/UserWidget';

type Props = {
  preferencesDialog: DialogState,
};

// Show in the funnel pages
export function FunnelWidgets({
  preferencesDialog,
}: Props): React.MixedElement {
  return (
    <>
      <PreferencesWidget dialog={preferencesDialog} />
      <UserWidget />
    </>
  );
}
